export const updateArrayItem = (array, updatedItem, key = 'id') => array.map((item) => (item[key] === updatedItem[key] ? updatedItem : item));

export const removeArrayItem = (array, deletedItem, key = 'id') => array.filter((item) => item[key] !== deletedItem[key]);
